/**
Table component. 
This uses the dynamic tables of the library ng-table. See http://ng-table.com/#/ for more information.

Settings example: 

  tableSettings = { 
    rowsPerPage = 10,        // optional, default 10
    striped: true,          
    condensed: true,
    
    enableSelection: true,
    selectionKey: 'id',
    selectionChange: fn(selectedRows),
    
    initialSortField: 'naam',
    initialSortOrder: 'desc',
    actions: [
      {desc:'add', icon: 'add', actionFn: doSomething(item)},
      {desc:'del', icon: 'del', actionFn: doSomething(item)}
    ],
    cols: [
        { field: 'aanspr', title: 'Aanspr.', sortable:'aanspr', width:'10%'},
        { field: 'naam',title:'Naam', sortable:'naam' }
        { field: 'desc',title:'Desc', sortable:'desc', show:false }
    ],
    data :[
        {
            'id': 1,
            'aanspr': 'Dhr. I am a test lorem ipsum dolor sit amet',
            'naam': 'Karel De keizer',
            'desc': 'Desc 1',
        },
        {
            'id': 2,
            'aanspr': 'Mevr.',
            'naam': 'Nina De Man',
            'desc': 'Desc 2',
        }
    ],
  }

  <vsko-table table=tableSettings><vsko-table>
*/

require('ng-table/bundles/ng-table.js');
require('ng-table/bundles/ng-table.css');

var vskoTable = angular.module('vskoTable', ['ngTable'])

.controller('tableCtrl',  ['$scope', '$attrs', 'NgTableParams',  '$element', function ($scope, $attrs, NgTableParams,  $element) {
  'use strict';
  var self = this;
  var table = $scope.table;

  $scope.getTableClass= function(column){
    var classes = [];
    if(table.condensed) {
      classes.push('table-condensed');
    }
    if(table.striped) {
      classes.push('table-striped');
    }
    if(table.enableSorting) {
      classes.push('table-sortable');
      // classes.push('table-enhanced-clickability');
    }
    return classes.join(' ');
  }

  $scope.getCellClass = function(row, col) {
    return col.field=== 'table_actions' ? 'table-actions-column' : '';
  }

  
  function init() {

    // Define column names
    if(!table.cols) {
      table.cols = [];
      angular.forEach(table.data[0],function (propValue, propName) {
        table.cols.push({
          field: propName,
        });
      });

    }
    // Denfine column titles
    table.cols.forEach(function (col){
      if(!col.title) {
        col.title= col.field.charAt(0).toUpperCase() + col.field.slice(1);
      }
    });

    // Actions
    if(table.actions && table.actions.length > 0) {
      table.cols.push({ field: 'table_actions', title: '', show: true, width:'1%' });

      $scope.doAction = function(action, item) {
          console.log('action '+ action.desc)
          if(action.actionFn){
            action.actionFn(item);
          }
      }
    }

    // Selections    
    if(table.enableSelection && table.selectionKey) {
      self.checkboxes = {
        checked: false,
        items: {}
      };
      if(table.cols[0].field !== 'table_selector') {
        table.cols.unshift({ field: 'table_selector', title: '', headerTemplateURL: 'headerCheckbox.html', show: true, width:'1%' });
      }

      // watch for check all checkbox
      $scope.$watch(function() {
          return self.checkboxes.checked;
        }, function(value) {
          table.data.forEach(function(item) {
            self.checkboxes.items[item[table.selectionKey]] = value;
          });
      });
      // watch for data checkboxes
      $scope.$watch(function() {
          return self.checkboxes.items;
        }, function(values) {
          var checked = 0, unchecked = 0, total = table.data.length;
          table.data.forEach(function(item) {
            checked   +=  (self.checkboxes.items[item[table.selectionKey]]) || 0;
            unchecked += (!self.checkboxes.items[item[table.selectionKey]]) || 0;
          });
          if ((unchecked == 0) || (checked == 0)) {
            self.checkboxes.checked = (checked == total);
          }
          // grayed checkbox
          angular.element($element[0].getElementsByClassName("select-all")).prop("indeterminate", (checked != 0 && unchecked != 0));

          if(angular.isDefined(table.selectionChange)) {
            var selectedRows = table.data.filter(function(item) {
              return self.checkboxes.items[item[table.selectionKey]]
            })
            table.selectionChange( selectedRows );
          }
      }, true);
    }
    
    var sort = {};
    sort[table.initialSortField] = table.initialSortOrder;

    var initialParams = {
        count: table.rowsPerPage || 10, // initial page size
        sorting: sort
    };
    var initialSettings = {
        counts: [],     // page size buttons (right set of buttons)
        dataset: table.data
    };
    self.tableParams = new NgTableParams(initialParams, initialSettings);
  }
  
  init();
}])


.directive('vskoTable', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-table.html'),
    controller: 'tableCtrl',
    controllerAs: 'tableCtrl',
    replace: false,
    scope: {
      table: '='
    },
  }
}]);
